export const FETCH_HOTELS = 'FETCH_HOTELS';
export const SET_HOTELS = 'SET_HOTELS';
export const FETCH_HOTELS_FAILED = 'FETCH_HOTELS_FAILED';
